// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "theme-bundle.chunk." + (chunkId === 423 ? "promo-assistant" : chunkId) + ".js";
};